import { FC } from "react";
import { publishSorting } from "./constants";
import CardDivider from "./footer/card-divider";
import { STATUS } from "@types";

const PublishFooter: FC<{ showDivider: boolean; status: STATUS }> = ({
  showDivider,
  status,
}) => {
  return (
    <>
      <CardDivider showDivider={showDivider} />
      <div className="flex  items-center h-fds-34 sm:h-9   -mt-[1px]">
        <p className="text-fds-brand button-sm">
          {publishSorting.findIndex((pItm) => pItm === status) <= 2
            ? "در فرایند انتشار"
            : "به زودی"}
        </p>
      </div>
    </>
  );
};

export default PublishFooter;
